import { createBlock, mergeBlock, t } from "@easy-email-pro-core/utils";

import { BasicType, ElementCategory } from "@easy-email-pro-core/constants";
import {
  TextNode,
  MergetagElement,
  ElementDefinition,
} from "@easy-email-pro-core/typings";
import React from "react";
import { BasicBlock, ContentLeaf } from "@easy-email-pro-core/components";
import { PluginManager } from "@easy-email-pro-core/utils/plugins/PluginManager";

const defaultData: ElementDefinition<MergetagElement>["defaultData"] = {
  attributes: {},
  data: {},
};

export const Mergetag = createBlock<MergetagElement>({
  get name() {
    return t("Mergetag");
  },
  defaultData,
  type: BasicType.MERGETAG,
  create: (payload) => {
    const defaultData: MergetagElement = {
      type: BasicType.MERGETAG,
      data: {},
      attributes: {},
      children: [],
    };
    return mergeBlock(defaultData, payload);
  },
  inlineElement: true,
  category: ElementCategory.INLINE_TEXT,
  render(params) {
    if (params.mode === "production") {
      const child = params.node.children[0] as TextNode;
      return (
        <ContentLeaf
          node={{
            ...child,
            text: PluginManager.generateVariable(
              child.text,
              params.node.data.default
            ),
          }}
        />
      );
    }
    return (
      <BasicBlock
        tag={"span"}
        params={{
          ...params,
          node: {
            ...params.node,
            attributes: {
              "element-type": BasicType.MERGETAG,
              "element-category": ElementCategory.INLINE_TEXT,
            } as any,
          },
        }}
      />
    );
  },
});
